/**
 * Directive used to prevent a user from creating more variants than the maximum
 */
angular.module('qkr').directive('select2VariantSetOptions', ['messageService', 'gettextCatalog', function(messageService, gettextCatalog) {
    return {
        restrict: 'A',
        scope: {
            maxVariantOptions: '&maxVariantOptions',
            variantSets: '&variantSets',
            currentVariantSet: '&currentVariantSet'
        },
        link(scope, element, attrs, ngModel) {
            const isDuplicateOption = function(variantSet, newOption) {
                if (variantSet != null && variantSet.options != null && variantSet.options.length > 0) {
                    const newOptionLowercase = newOption.toLowerCase();

                    for (let i = 0; i < variantSet.options.length; i++) {
                        const option = variantSet.options[i];

                        if (newOptionLowercase == option.toLowerCase()) {
                            return true;
                        }
                    }
                }

                return false;
            };

            element.on('select2-selecting', (event) => {
                // First ensure the option isn't a duplicate
                if (isDuplicateOption(scope.currentVariantSet(), event.val)) {
                    event.preventDefault();
                }

                let numberOfOptions = 0;

                // Calculate the max number of variants if the current selection
                // Is allowed to be added
                angular.forEach(scope.variantSets(), (variantSet) => {
                    if (variantSet.variantType != null && variantSet.options != null) {
                        let numOptionsInList = variantSet.options.length;

                        // If this is the current variant set, add one as this
                        // Will be the number of options in the list after the
                        // Add has completed
                        if (scope.currentVariantSet().variantType != null && scope.currentVariantSet().variantType == variantSet.variantType) {
                            numOptionsInList++;
                        }

                        if (numberOfOptions == 0) {
                            numberOfOptions = numOptionsInList;
                        } else {
                            numberOfOptions = (numOptionsInList * numberOfOptions);
                        }
                    }
                });

                if (numberOfOptions > scope.maxVariantOptions()) {
                    messageService.warning(gettextCatalog.getString('The maximum number of variants has been reached'));
                    event.preventDefault();
                    element.select2('close');
                }
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/select2_variant_set_options.js